import styled from "styled-components/";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;

  .card-container {
    display: flex;
    gap: 16px;
    img {
      width: 120px;
      height: 120px;
      object-fit: cover;
      border-radius: 6px;
    }
  }

  .shop-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .product-title {
    font-weight: bold;
    font-size: 16px;
  }

  .date {
    color: ${({ theme }) => theme.COLORS.GRAY_700};
    font-size: 14px;
  }

  .old-price {
    color: ${({ theme }) => theme.COLORS.GRAY_700};
    font-size: 14px;
    text-decoration: line-through;
  }

  .new-price {
    color: ${({ theme }) => theme.COLORS.GREEN};
    font-weight: bold;
    font-size: 20px;
  }

  .shop-name {
    font-size: 18px;
  }

  .shop-location {
    color: ${({ theme }) => theme.COLORS.GRAY_700};
    font-size: 14px;
  }

  .text-bold {
    font-weight: bold;
  }
`;

export const ButtonInstagram = styled.a`
  background: #5B51D8;
  color: #fff;
  width: 100%;
  border: none;
  padding: 16px 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  cursor: pointer;
  text-decoration: none;
`;

export const EmptyContactMessage = styled.p`
  color: ${({ theme }) => theme.COLORS.GRAY_700};
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
`;
